import { getString } from "../../common/common";

export const TAB3_HEADING1 = "TAB3_HEADING1";
export const TAB3_HEADING2 = "TAB3_HEADING2";
export const TAB3_HEADING3 = "TAB3_HEADING3";
export const TAB3_LI1 = "TAB3_LI1";
export const TAB3_LI2 = "TAB3_LI2";
export const TAB3_LI3 = "TAB3_LI3";
export const TAB3_LI4 = "TAB3_LI4";
export const TAB3_LI5 = "TAB3_LI5";

export const translations = {
  en: {
    [TAB3_HEADING1]: "Airavat Bliss",
    [TAB3_HEADING2]: "Multi-axle buses with special amenities",
    [TAB3_HEADING3]: "The silent features of Airavat are as follows:",
    [TAB3_LI1]: "Dashboard controls for all cubicle actions.",
    [TAB3_LI2]: "Vacant, occupied & disabled status with display light.",
    [TAB3_LI3]:
      "Auto flush if the passenger has left the toilet without flushing.",
    [TAB3_LI4]: "Hand wash system with '10 seconds' water saving operation.",
    [TAB3_LI5]: "Easy to operate system to help clean out waste.",
  },
  kn: {
    [TAB3_HEADING1]: "ಐರಾವತ್ ಬ್ಲಿಸ್",
    [TAB3_HEADING2]: "ವಿಶೇಷ ಸೌಕರ್ಯಗಳೊಂದಿಗೆ ಮಲ್ಟಿ-ಆಕ್ಸಲ್ ಬಸ್ಸುಗಳು",
    [TAB3_HEADING3]: "ಐರಾವತದ ವಿಶೇಷ ಲಕ್ಷಣಗಳು ಹೀಗಿವೆ:",
    [TAB3_LI1]: "ಎಲ್ಲಾ ಕ್ಯುಬಿಕಲ್ ಕ್ರಿಯೆಗಳಿಗೆ ಡ್ಯಾಶ್‌ಬೋರ್ಡ್ ನಿಯಂತ್ರಣಗಳು.",
    [TAB3_LI2]: "ಡಿಸ್ಪ್ಲೇ ಲೈಟ್‌ನೊಂದಿಗೆ ಖಾಲಿ, ಆಕ್ರಮಿತ ಮತ್ತು ನಿಷ್ಕ್ರಿಯ ಸ್ಥಿತಿ.",
    [TAB3_LI3]:
      "ಪ್ರಯಾಣಿಕರು ಫ್ಲಶ್ ಮಾಡದೆ ಶೌಚಾಲಯದಿಂದ ಹೊರಬಂದಿದ್ದರೆ ಆಟೋ ಫ್ಲಶ್ ಆಗುತ್ತದೆ.",
    [TAB3_LI4]:
      "10 ಸೆಕೆಂಡ್‌ಗಳ' ನೀರಿನ ಉಳಿತಾಯ ಕಾರ್ಯಾಚರಣೆಯೊಂದಿಗೆ ಕೈ ತೊಳೆಯುವ ವ್ಯವಸ್ಥೆ.",
    [TAB3_LI5]:
      "ತ್ಯಾಜ್ಯವನ್ನು ಸ್ವಚ್ಛಗೊಳಿಸಲು ಸಹಾಯ ಮಾಡಲು ಸುಲಭವಾದ ಆಪರೇಟಿಂಗ್ ಸಿಸ್ಟಮ್.",
  },
};

export const t = (key = "") => {
  return getString(key, translations);
};
